import React from "react";
import styles from "./weekTooltipLabel.module.scss";
import { useTranslation } from "react-i18next";

interface WeekTooltipLabelProps {
  weekLabel: string;
  startingDate: string;
  endingDate: string;
  isNotEditable?: boolean;
}

const WeekTooltipLabel = ({
  weekLabel,
  startingDate,
  endingDate,
  isNotEditable,
}: WeekTooltipLabelProps) => {
  const { t } = useTranslation();

  return (
    <div className={styles.weekTooltipLabel}>
      <p className={styles.weekTooltipLabel_info}>
        <span className={styles.weekTooltipLabel_week}>{weekLabel}</span>{" "}
        {`${startingDate} ${t("calendar-view.weekly.tooltip-date-separator")} ${endingDate}`}
      </p>

      {isNotEditable && <p>{t("assignation-edit.past-sessions.week-tooltip.not-editable")}</p>}
    </div>
  );
};

export default WeekTooltipLabel;
